import axios from 'axios';

// Create an Axios instance
const httpClient = axios.create({
    // baseURL: 'http://192.168.0.239:8080', // Set your base URL here
    // baseURL: 'http://47.94.85.192:8080', // Set your base URL here
    baseURL: 'https://steam.yilink.tech/api', // Set your base URL here
    timeout: 5000, // Set default timeout to 5 seconds
    headers: {
        'content-type': 'application/json',
        'Accept': 'application/json',
    },
});

// Request interceptor to add token
httpClient.interceptors.request.use(
    (config) => {
        if (!navigator.onLine) {
            alert("网络未连接,请检查您的网络设置");
            return Promise.reject(new Error("网络未连接"));
        }
        const token = localStorage.getItem('token'); // Retrieve token from localStorage or other storage
        // 判断jwt格式的token是否过期
        if (token && token.startsWith('eyJ')) {
            try {
                const payload = JSON.parse(atob(token.split('.')[1]));
                const exp = payload.exp * 1000; // Convert to milliseconds
                console.log("Token过期时间:", new Date(exp).toLocaleString());
                if (Date.now() >= exp) {
                    alert("登录已过期,请重新登录");
                    localStorage.clear();
                    return Promise.reject(new Error("登录已过期"));
                }
            } catch (e) {
                console.error("Token解析错误:", e);
            }
        }
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor for retries and handling unauthorized errors
httpClient.interceptors.response.use(
    (response) => response,
    async (error) => {

        // Handle unauthorized errors (e.g., 401)
        if (error.response && error.response.status === 401) {
            // Redirect to login page
            window.location.href = '/login';
            return Promise.reject(error);
        }

        // if (error.response?.data && error.response.data.code === 1001) {
        //     // Redirect to login page
        //     alert('登录已失效');
        //     localStorage.clear();
        //     location.reload();
        //     return Promise.reject(error);
        // }

        // Retry logic for timeout errors only
        const config = error.config;
        if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
            if (!config || !config.retry) {
                config.retry = 0;
            }

            if (config.retry < 2) { // Retry up to 2 times
                config.retry += 1;
                return httpClient(config); // Retry the request
            }
        }

        return Promise.reject(error);
    }
);

export default httpClient;